export default "/images/ab3579dba39ad628e067be079b7cff39.avif";